<template lang="pug">
  button.btn.btn-primary(:disabled='loading')
    .spinner-border.spinner-border-sm.mr-2(v-if='loading')
    slot
</template>

<script>
export default {
  props: {
    loading: Boolean,
  },
}
</script>